module.exports = __webpack_public_path__ + "static/becoming-christmas-karen-f22e90af28b057d25ae381dc0c54ed3f.jpg";